import { QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED } from '../../constants/qa'

export const REQUEST_PHASE_PROGRESS_MAX = 100

export const REQUEST_PHASE_PROGRESS_MIN = 0

export const RequestPhaseItemStatus = {
  finished: 'finished',
  inProgress: 'inProgress',
  notStarted: 'notStarted',
}

export const REQUEST_ALL_ITEMS_PAGINATION = 50

export const REQUEST_MINIMIZED_REPLACE_CONFIRMATION = {
  description: 'Modal.MinimizedRequestDraftSavedConfirmationTextKey',
  qaName: QA_NAME_CONFIRMATION_MINIMIZED_REPLACE_DRAFT_SAVED,
}

// Marker added to a user option that was auto-filled by the AI Wizard, so the
// address auto-complete cascade does not overwrite the AI-resolved building/flat.
// Lives here (Request-level shared constants) so the cascade hook can read it
// without importing the wizard, which would create a circular import.
export const REQUEST_WIZARD_AI_WIZARD_USER_AUTOFILLED_KEY = 'isAIAutofilled'
